import { RootState } from '@tabeeb/store'

export const getCheckInsFilterModel = (state: RootState) => state.checkIns.filterModel
